if (!customElements.get('caene-product-reviews')) {
  customElements.define('caene-product-reviews', class extends HTMLElement {
    connectedCallback() {
      const full = this.querySelector('[data-review-full]');
      const spotlight = this.querySelector('.cpr__spotlight');
      const toggle = this.querySelector('[data-review-toggle]');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      let reviews = [], index = 0, initialized = false, average = '';
      const configuredReviews = (() => {
        const source = this.querySelector('[data-featured-reviews]');
        if (!source) return [];
        try {
          const parsed = JSON.parse(source.textContent || '[]');
          if (!Array.isArray(parsed)) return [];
          return parsed
            .filter(review => review?.body && review?.author)
            .map(review => ({
              body: String(review.body).trim(),
              author: String(review.author).trim(),
              verified: review.verified === true
            }));
        } catch (error) {
          console.warn('Unable to parse featured reviews', error);
          return [];
        }
      })();
      const show = () => {
        const review = reviews[index];
        if (!review) return;
        this.querySelector('[data-review-quote]').textContent = review.body;
        this.querySelector('[data-review-author]').textContent = review.author;
        this.querySelector('[data-review-verified]').hidden = !review.verified;
        const stars = this.querySelector('[data-review-stars]');
        const rating = Number(average.replace(',', '.'));
        stars.textContent = '★★★★★';
        stars.style.setProperty('--rating-fill', `${Math.max(0, Math.min(5, rating)) / 5 * 100}%`);
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${average} out of 5 stars`);
        previous.disabled = next.disabled = reviews.length < 2;
      };
      const sync = () => {
        const parsed = [...full.querySelectorAll('.oke-w-review')].map(row => ({
          body: row.querySelector('.oke-reviewContent-body')?.textContent.trim(),
          author: row.querySelector('.oke-w-reviewer-name')?.textContent.trim(),
          verified: !!row.querySelector('.oke-w-reviewer-verified'),
          stars: row.querySelector('.oke-reviewContent-stars')
        })).filter(review => review.body && review.author && review.stars);
        const nextReviews = configuredReviews.length ? configuredReviews : parsed;
        if (!nextReviews.length) return;
        reviews = nextReviews;
        index = Math.min(index, reviews.length - 1);
        average = full.querySelector('.oke-w-ratingAverageModule-rating-average')?.textContent.trim() || '';
        this.querySelector('[data-review-summary]').textContent = average ? `(${average} out of 5)` : '';
        if (!initialized) { full.hidden = true; spotlight.hidden = false; initialized = true; }
        toggle.textContent = full.hidden ? 'Read all reviews' : 'Close all reviews';
        show();
      };
      this.controller = new AbortController();
      const {signal} = this.controller;
      previous.addEventListener('click', () => {index = (index - 1 + reviews.length) % reviews.length;show();}, {signal});
      next.addEventListener('click', () => {index = (index + 1) % reviews.length;show();}, {signal});
      toggle.addEventListener('click', () => {
        full.hidden = !full.hidden;
        toggle.setAttribute('aria-expanded', String(!full.hidden));
        toggle.textContent = full.hidden ? 'Read all reviews' : 'Close all reviews';
      }, {signal});
      const openFromRating = (event) => {
        if (!initialized || !event.target.closest('[id^="ProductInfo-"] .oke-is-clickable')) return;
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      };
      document.addEventListener('click', openFromRating, {signal,capture:true});
      document.addEventListener('keydown', openFromRating, {signal,capture:true});
      this.observer = new MutationObserver(sync);
      this.observer.observe(full, {childList:true,subtree:true,characterData:true});
      sync();
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();}
  });
}
